"use client";
import { Sidebar } from "@/components/Sidebar";
import { PodcastCRM } from "@/components/PodcastCRM";

export default function PodcastsPage() {
  return (
    <div className="flex h-screen bg-[var(--bg)]">
      <Sidebar />
      <main className="flex-1 overflow-y-auto p-6">
        <PodcastCRM />
      </main>
    </div>
  );
}
